import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "fixed top-0 left-0 right-0 z-40 transition-all duration-500 bg-gascon-blue py-2" }
const _hoisted_2 = { class: "container mx-auto px-4 flex items-center justify-between" }
const _hoisted_3 = {
  key: 0,
  src: "/images/header_menu.svg",
  alt: "Menu",
  class: "w-8 h-8"
}
const _hoisted_4 = {
  key: 1,
  class: "w-8 h-8 text-white",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_5 = {
  key: 0,
  class: "bg-gascon-blue border-t border-white/10"
}
const _hoisted_6 = { class: "container mx-auto px-4 py-6" }
const _hoisted_7 = { class: "space-y-4 font-raleway" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" Hamburger menu "),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = (...args) => ($options.toggleMenu && $options.toggleMenu(...args))),
        class: "p-2 hover:opacity-80 hover:cursor-pointer transition-opacity"
      }, [
        (!$data.menuOpen)
          ? (_openBlock(), _createElementBlock("img", _hoisted_3))
          : (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M6 18L18 6M6 6l12 12"
              }, null, -1 /* CACHED */)
            ]))]))
      ]),
      _createCommentVNode(" Logo placeholder (actual logo is animated from HeroSection) "),
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "w-32 h-10" }, null, -1 /* CACHED */)),
      _createCommentVNode(" Contact link "),
      _cache[9] || (_cache[9] = _createElementVNode("a", {
        href: "#contact",
        class: "text-white hover:text-gascon-gold transition-colors font-semibold font-raleway"
      }, " Contact ", -1 /* CACHED */))
    ]),
    _createCommentVNode(" Mobile menu "),
    _createVNode(_Transition, { name: "slide" }, {
      default: _withCtx(() => [
        ($data.menuOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("nav", _hoisted_6, [
                _createElementVNode("ul", _hoisted_7, [
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: "#hero",
                      onClick: _cache[1] || (_cache[1] = (...args) => ($options.closeMenu && $options.closeMenu(...args))),
                      class: "block text-white hover:text-gascon-gold transition-colors"
                    }, "Home")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: "#news",
                      onClick: _cache[2] || (_cache[2] = (...args) => ($options.closeMenu && $options.closeMenu(...args))),
                      class: "block text-white hover:text-gascon-gold transition-colors"
                    }, "À la une")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: "#contact",
                      onClick: _cache[3] || (_cache[3] = (...args) => ($options.closeMenu && $options.closeMenu(...args))),
                      class: "block text-white hover:text-gascon-gold transition-colors"
                    }, "Contact")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: "#gallery",
                      onClick: _cache[4] || (_cache[4] = (...args) => ($options.closeMenu && $options.closeMenu(...args))),
                      class: "block text-white hover:text-gascon-gold transition-colors"
                    }, "Dans vos cuisines")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: "#team",
                      onClick: _cache[5] || (_cache[5] = (...args) => ($options.closeMenu && $options.closeMenu(...args))),
                      class: "block text-white hover:text-gascon-gold transition-colors"
                    }, "Nos Gars")
                  ])
                ]),
                _createElementVNode("a", {
                  href: "#contact",
                  onClick: _cache[6] || (_cache[6] = (...args) => ($options.closeMenu && $options.closeMenu(...args))),
                  class: "mt-6 inline-block bg-gascon-gold text-gascon-blue px-8 py-3 font-semibold hover:opacity-90 hover:cursor-pointer transition-opacity rounded"
                }, " Catalogue ")
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}